import { useTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import getLullabyIcon from "src/modules/lullaby/icons/getLullabyIcon";
import { Subtitle, H2 } from "src/atoms/typography";

import CircleAnimation from "./CircleAnimation";
import LullabySelect from "./LullabySelect";
import Background from "./Background";
import LullabyPlayerCurrentTime from "./LullabyPlayerCurrentTime";
import LullabyPlayerTimer from "./LullabyPlayerTimer";
import AudioController from "./AudioController";

export default function LullabyPlayerView({
  otherLullabies,
  defaultLullaby,
  lullabyPlayer
}) {
  const { t } = useTranslation();
  const { status } = lullabyPlayer;

  const playingSubtitle =
    lullabyPlayer.stationType === "parent"
      ? t("lullaby.parentPlayer.playingSubtitle")
      : t("babyStation");
  const stoppedSubtitle =
    lullabyPlayer.stationType === "parent"
      ? t("lullaby.parentPlayer.stoppedSubtitle")
      : t("babyStation");
  const disableButtons =
    status === lullabyPlayer.Status.LOADING ||
    status === lullabyPlayer.Status.STOPPING;
  return (
    <Flex height="100%">
      <Box
        bg="primaryLight"
        width="264px"
        mr="16px"
        p="16px"
        borderRadius="13px"
        position="relative"
      >
        <Background
          icon={getLullabyIcon(defaultLullaby.libraryIdentifier || "record")}
        />
        <Flex
          flexDirection="column"
          alignItems="center"
          width="232px"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
        >
          {status === lullabyPlayer.Status.PLAYING && (
            <Box zIndex={-1} position="absolute">
              <CircleAnimation />
            </Box>
          )}
          <AudioController lullabyPlayer={lullabyPlayer} />
          <H2 mt="20px" color="highEmphasis">
            {defaultLullaby.source === "record"
              ? defaultLullaby.name
              : t(`lullaby.name.${defaultLullaby.libraryIdentifier}`)}
          </H2>
          <Subtitle color="mediumEmphasis">
            {status === lullabyPlayer.Status.PLAYING
              ? playingSubtitle
              : stoppedSubtitle}
          </Subtitle>
        </Flex>
        <Box
          position="absolute"
          bottom="16px"
          left="50%"
          transform="translateX(-50%)"
        >
          <LullabyPlayerCurrentTime
            lullabyPlayer={lullabyPlayer}
            lullaby={defaultLullaby}
          />
        </Box>
      </Box>
      <Box flex="1 1 auto">
        <LullabySelect
          onSelect={lullabyPlayer.select}
          defaultLullaby={defaultLullaby}
          otherLullabies={otherLullabies}
          disabled={disableButtons}
        />
        <Box mt="16px" />
        <LullabyPlayerTimer
          onSubmit={lullabyPlayer.updateTimerSettings}
          timerSettings={lullabyPlayer.timerSettings}
          disabled={disableButtons}
        />
      </Box>
    </Flex>
  );
}
